var _path, _rect, _path2, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStorefrontMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 42 L22 53 L29 42 Z",
    fill: "#7A5AF8",
    stroke: "white",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 14,
    fill: "#7A5AF8",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18 L31 18 L29 14 L15 14 Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19,
    width: 16,
    height: 13,
    rx: 1,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 4,
    height: 8,
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefrontMarker);
export default __webpack_public_path__ + "static/media/storefront-marker.eb53f776ff8f0d1b9239d4dc7e5e4e9b.svg";
export { ForwardRef as ReactComponent };